import {LOGIN, GENERATE_OPT, VERIFY_OPT} from './constants';
import {Payload, PayloadGenerateOpt} from './interfaces';

export function loginAction(payload: Payload) {
  return {
    type: LOGIN,
    payload,
  };
}

export function generateOptAction(payload: PayloadGenerateOpt) {
  return {
    type: GENERATE_OPT,
    payload,
  };
}

export function verifyOtpAction(payload: {
  code: string;
  phoneNumber: string;
  rememberMe: boolean;
}) {
  return {
    type: VERIFY_OPT,
    payload,
  };
}
